import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login'
import { isLoggedIn } from '../utils/auth'

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/operation',
    name: 'operationManage',
    component: () => import('../views/Operation/OperationManage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/cloud',
    name: 'cloud',
    component: () => import('../views/Cloud/CloudLibrary.vue'),
    meta: { requiresAuth: true } // 设置需要登录才能访问的路由
  },
  {
    path: '/agri/trades',
    name: 'tradeManage',
    component: () => import('../views/Agri/TradeManage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/agri/reports',
    name: 'reportManage',
    component: () => import('../views/Agri/ReportManage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/agri/varieties',
    name: 'varietyManage',
    component: () => import('../views/Agri/VarietyManage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/agri/search-terms',
    name: 'searchTermManage',
    component: () => import('../views/Agri/SearchTermManage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/agri/categories',
    name: 'categoryManage',
    component: () => import('../views/Agri/CategoryManage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/agri/market',
    name: 'marketManage',
    component: () => import('../views/Agri/MarketManage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/company/list',
    name: 'companyManage',
    component: () => import('../views/Company/CompanyManage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/list',
    name: 'userManage',
    component: () => import('../views/User/UserManage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/list',
    name: 'adminManage',
    component: () => import('../views/Admin/AdminManage.vue'),
    meta: { requiresAuth: true }
  },
  // 兜底：地址写错 / 收藏了已删除的页面时，别停在白屏
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' }
  }
]

const router = createRouter({
  history: createWebHistory(), // 去掉#号
  routes
})

// 导航守卫
// 判断依据是「token 存在且未过期」（utils/auth.js），不再只看 isLogin 这个字符串标记：
// 旧逻辑只要 localStorage 里有 isLogin（哪怕是 'false'）就放行，token 过期也照进不误。
router.beforeEach((to) => {
  const authed = isLoggedIn()

  // 需要登录的页面
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!authed) {
      // 记住原本要去的地址，登录后跳回来
      return { path: '/', query: to.fullPath === '/' ? {} : { redirect: to.fullPath } }
    }
    return true
  }

  // 已登录还去登录页 → 直接进后台
  if (to.name === 'login' && authed) {
    return { name: 'dashboard' }
  }

  return true
})

export default router
